export enum LocalStorageItems {
  DARKMODE = "agClubhouseDarkModeActive",
  DASHBOARDQUEUE = "agClubhouseDashboardQueue",
  DASHBOARDGRIDORLISTVIEW = "agClubhouseDashboardGridOrListView",
  SHOWEVENTSLIST = "agClubhouseEventsList",
  BROWSERID = "agClubhouseBrowserId",
  LOCKERROOMDATERANGE = "agClubhouseLockerRoomDateRange",
  LEAGUEFILTERS = "agClubhouseLeagueFilters",
}

export function localStorageValueToBoolean(value: string | null): boolean {
  return value && value === "true" ? true : false;
}

// Storage access throws under strict privacy settings and some embedded or
// kiosk contexts. These helpers back UI preferences, so a lost value is
// acceptable — an uncaught SecurityError in a render path is not.
export function getLocalStorageValue(key: string): string {
  try {
    return localStorage.getItem(key) ?? "";
  } catch {
    return "";
  }
}

export function setLocalStorageValue(key: string, value: string) {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Preference not persisted; in-memory state still applies.
  }
}

export function getSessionStorageValue(key: string): string {
  try {
    return sessionStorage.getItem(key) ?? "";
  } catch {
    return "";
  }
}

export function setSessionStorageValue(key: string, value: string) {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    // Preference not persisted; in-memory state still applies.
  }
}
